import { render, staticRenderFns } from "./award.vue?vue&type=template&id=015eed54&scoped=true&"
import script from "./award.vue?vue&type=script&lang=ts&"
export * from "./award.vue?vue&type=script&lang=ts&"
import style0 from "./award.vue?vue&type=style&index=0&id=015eed54&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015eed54",
  null
  
)

export default component.exports